import React from 'react'
import { Link } from 'react-router-dom';
import SRTCirculo from '../../img/SRTCirculo.webp';

const Srt = () => {
    return (
        <>
            <div className="bg-latitud animated fadeIn" >
                <div className="container section">
                    <div className="row">
                        <div className="center-vertical">
                            <div className="col s12 m12 l6 x6 center">
                                <Link href="https://www.argentina.gob.ar/srt"  target="_blank"><img src={SRTCirculo} className="responsive-img"/></Link>
                            </div>
                            <div className="col s12  m12 l6  x6 center text-white">
                                <strong style={{"font-size":"25px"}}>¿Cómo actuar en caso de accidente?</strong><br/><br/>
                                <strong style={{"font-size":"20px"}}>Atención de Denuncias</strong><br/>
                                <span style={{"font-size":"18px"}}>0800 199 0022</span><br/><br/>
                                <strong style={{"font-size":"20px"}}>Guardia</strong><br/>
                                <span style={{"font-size":"18px"}}>0388 156 867 840</span>/<br/><br/>
                                <Link to={"accidente"} className="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Ver más
                                    <i className="material-icons right">send</i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Srt